const React = require('react');

export function ThemePreview(glob, theme) {
    return [
        <div key={'widget-inner-container'} className="widget">
            <div className="widget-inner-container">
                <div className="widget-control-panel">
                    <span>Clock Widget</span>
                    <span className="glyphicon glyphicon-remove remove-button header-button"></span>
                    <span className="glyphicon glyphicon-cog config-button header-button"></span>
                    <span className="glyphicon glyphicon-chevron-down menu-button header-button"></span>
                </div>
                <div className="show-header-button">
                    <span className="glyphicon glyphicon-chevron-down"></span>
                </div>
                <div className="widget-canvas widget-canvas-main">
                    <div className="pdc-widget-clock">
                        <div className="time-text">{'Wednesday, 24 December 2014 15:02'}</div>
                    </div>
                </div>
            </div>
        </div>
    ];
}
